import { IOnlinePatientManagement } from "@ngt/opms";
import { IReturn } from "@servicestack/client";
import { SWRConfiguration } from "swr";
import IApiConfiguration from "../../types/IApiConfiguration";
import useApi from "./useApi";

export const useGet = <T, D, E, A>(fn?: (opms: IOnlinePatientManagement) => IReturn<T>, getConfiguration?: IApiConfiguration<T, D, E, A>, swrConfiguration?: SWRConfiguration | undefined) => {
    return useApi('get', fn, getConfiguration, swrConfiguration);
}

export default useGet;